export const leadershipMembers = [
  // Board of Directors
  { name: "David Mazzo", slug: "david-mazzo", category: "Independent Director" },
  { name: "Shaun Jackson", slug: "shaun-jackson", category: "Founder and Director" },
  // Senior Management
  { name: "Peter Bush", slug: "peter-bush", category: "Chief Executive Officer" },
  { name: "Simone Schoenwaelder", slug: "simone-schoenwaelder", category: "Head, Biology" },
  { name: "Simon Jackson", slug: "simon-jackson", category: "Chief Information Officer" },
  { name: "Dr. Sundeep Dugar", slug: "sundeep-dugar", category: "Drug Discovery" },
  { name: "Amos Meltzer", slug: "amos-meltzer", category: "Corporate Development" },
  // Corporate Advisors
  { name: "Rod Jackson", slug: "rod-jackson", category: "Senior Advisor" },
  { name: "Mithran Doraisamy", slug: "mithran-doraisamy", category: "Strategic Consultant" }
];

export const clinicalTrials = [
  { name: "STARS", slug: "stars", category: "Clinical Trial" },
  { name: "CoSTARS", slug: "costars", category: "Clinical Trial" }
];

export const technology = [
  { name: "Our Lead Candidate", slug: "candidate", category: "Technology" },
  { name: "Lead Indications", slug: "leadindication", category: "Technology" }
];

export const media = [
  { name: "Nature", slug: "nature", category: "Media" },
  { name: "ABC News", slug: "abc", category: "Media" },
  { name: "J.P. Morgan Conference", slug: "jpmorgan", category: "Media" },
  { name: "9News", slug: "ninenews", category: "Media" },
  { name: "Gordon Research Conference", slug: "gordonresearch", category: "Media" },
  { name: "NBN News", slug: "nbnnews", category: "Media" },
  { name: "Newcastle Herald", slug: "newcastleherald", category: "Media" }
];